import Layout from './Layout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DocumentVerification from './pages/DocumentVerification'
import Home2 from './pages/PassportVerification'
import { getLocale, t } from './locale'
import Index from './pages/PersonalData'
import VideoForm from './pages/VideoVerification';
import Payment from './pages/PaymentForm';
import FaceIdentification from './pages/FaceVerification';
import AdminLogin from './pages/admin/AdminLogin'
import AdminCheck from './pages/admin/Admin'
import Report from './pages/ReportPreview'
import Success from './pages/SuccessPage'
import './index.scss';
import './style.css'
import SetPassword from './pages/admin/AdminSetPassword';
import PinCode from './pages/admin/PinCode';
import ForgotPassword from './pages/admin/ForgotPassword';
import { showKAlert } from './helpers/helpers';
import VideoIdentificationPage from './pages/admin/AdminDetails';
import MaintenancePage from './pages/MaintenancePage';
import CompanySelect from './components/CompanySelect';
import { ReactElement, useEffect, useState } from 'react';
import RequestStatusGate from './pages/RequestStatusGate';
import RequestStatusPage from './pages/RequestStatusPage';

document.documentElement.setAttribute('lang', getLocale())
const { fetch: originalFetch } = window

window.fetch = async (resource: any, options: any = {}) => {
  window.dispatchEvent(new Event('startFetch'))
  
  const headers = options.headers ?? {}
  headers['x-api-key'] = sessionStorage.getItem('impersonationToken') ?? process.env.REACT_APP_API_KEY
  const accessToken = sessionStorage.getItem('accessToken')
  if (accessToken) headers['accessToken'] = accessToken

  options.headers = headers

  const res = originalFetch(resource, options)
  res.then(r => {

    window.dispatchEvent(new Event('endFetch'))
    !!r && r.status === 403 && showKAlert('danger', 'forbidden')
    !!r && r.status === 404 && showKAlert('danger', t('serverError'))
    !!r && r.status === 500 && showKAlert('danger', t('serverError'))

  }).catch((err) => {
    showKAlert('danger', 'networkError')
  })
  return res
}

function App() {
  const [maintenance, setMaintenance] = useState<boolean | null>(null)
  const checkStatus = (element: ReactElement) => (
    <RequestStatusGate>{element}</RequestStatusGate>
  )

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/maintenance`)
      .then(res => res.json())
      .then(data => setMaintenance(data.maintenance === true))
      .catch(() => setMaintenance(false))
  }, [])

  if (maintenance === null) return null

  if (maintenance) return <MaintenancePage />

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route path=':companyId/:requestId/p' index element={checkStatus(<Index />)}></Route>
          <Route path=':company_id/:id/si/false/p' index element={checkStatus(<DocumentVerification />)}></Route>
          <Route path=':company_id/:id/si/true/p' index element={checkStatus(<Home2 />)}></Route>
          <Route path=':company_id/:id/si/payment/p' index element={checkStatus(<Payment />)}></Route>
          <Route path=':companyId/:requestId/form_data' element={checkStatus(<Index />)} />
          <Route path=':companyId/:requestId/video' element={checkStatus(<VideoForm />)} />
          <Route path=':companyId/:requestId/face_identify' element={checkStatus(<FaceIdentification />)} />
          <Route path=':companyId/:requestId/status' element={<RequestStatusPage />} />
          <Route path='ds_id_verification/login' element={<AdminLogin />} />
          <Route path='ds_id_verification' element={<AdminCheck />} />
          <Route path='ds_id_verification/confirm/:accessToken' element={<SetPassword reset={false} />} />
          <Route path='ds_id_verification/password-set/:accessToken' element={<SetPassword reset={true} />} />
          <Route path='ds_id_verification/pincode-validation/' element={<PinCode />} />
          <Route path='ds_id_verification/forgot-password' element={<ForgotPassword />} />
          <Route path='report/preview/:id' element={<Report />} />
          <Route path='ds_id_verification/company-select' element={<CompanySelect />} />
          <Route path='ds_id_verification/admin/detail/:company_id/:request_id' element={<VideoIdentificationPage/>}/>
          <Route path='success' element={<Success/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
